<template>
  <v-data-table
    :headers="headers"
    :items="tasks"
    sort-by="id"
    class="elevation-1 dark-last-row"
    hide-default-footer
    item-key="id"
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="primary"
      >
        <v-toolbar-title class="white--text">Tasks</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              tile
              depressed
              large
            >
              <v-icon dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>
          <v-card flat color="#004889">
            <v-card-title class="accent">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

           <v-card-text class="pa-0">
              <ValidationObserver ref="observer1">
                <v-form ref="warrantyform">
                  <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Property</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <ValidationProvider v-slot="{ errors }" name="Property" rules="required">
                            <v-select
                                v-model="editedItem.property_id"
                                :items="properties"
                                item-text="title"
                                item-value="id"
                                required
                                :error-messages="errors"
                                solo
                                flat
                                dark
                                @change="getContacts"
                            ></v-select>
                          </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Task</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Task" rules="required">
                              <v-text-field
                                v-model="editedItem.task"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Description</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Description" rules="required">
                              <v-textarea
                                v-model="editedItem.description"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-textarea>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Contact</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Contact" rules="required">
                              <v-select
                                  v-model="editedItem.contact"
                                  :items="contacts"
                                  item-text="name"
                                  item-value="id"
                                  required
                                  :error-messages="errors"
                                  solo
                                  flat
                                  dark
                                  multiple
                              ></v-select>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Status</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                            <v-select
                                v-model="editedItem.status"
                                :items="statuses"
                                item-text="label"
                                item-value="value"
                                required
                                :error-messages="errors"
                                solo
                                flat
                                dark
                            ></v-select>
                          </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Date</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-menu
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                          >
                              <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="computedDateFormatted"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  solo
                                  flat
                                  dark
                                  clearable
                              ></v-text-field>
                              </template>
                              <v-date-picker
                              v-model="editedItem.date"
                              @input="menu = false"
                              ></v-date-picker>
                          </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Assignee</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <ValidationProvider v-slot="{ errors }" name="Assignee" rules="required">
                            <v-select
                                v-model="editedItem.assignee"
                                :items="users"
                                item-text="name"
                                item-value="id"
                                :error-messages="errors"
                                clearable
                                solo
                                flat
                                dark
                            ></v-select>
                          </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="accent">
              <v-btn
                large min-width="49%" color="white" text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
                :loading="loading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card color="red">
            <v-card-title class="subtitle-2 justify-center white--text">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions class="red darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn large min-width="50%" color="primary" tile @click="editItem(item)">      
        <v-icon
        >
          mdi-pencil
        </v-icon>
      </v-btn>             
      <v-btn large min-width="50%" color="red" tile @click="deleteItem(item.id)">
        <v-icon
        color="white"
        >
        mdi-delete
      </v-icon>  
      </v-btn>  
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="getTasks"
        tile
        :loading="loading"
      >
        No Items Found. Click Here to Refresh!
      </v-btn>
    </template>
    <template v-slot:item.task="props">
      <v-edit-dialog
        :return-value.sync="props.item.task"
        @save="saveField(props.item.id)"
        large
      >
        {{ props.item.task }}
        <template v-slot:input>
          <v-text-field
            v-model="props.item.task"
            label="Edit"
            single-line
            counter
          ></v-text-field>
        </template>
      </v-edit-dialog>
    </template>
    <template v-slot:item.property="{ item }">
      <v-btn text :to="`/property/edit/${item.property.id}`">
        {{ item.property.street_address + ' ' + item.property.city }}
      </v-btn>  
    </template>
    <template v-slot:item.status="props">
      <v-edit-dialog
        :return-value.sync="props.item.status"
        @save="saveField(props.item.id)"
        large
      >
        <v-chip
          color="green"
          text-color="white"
          v-if="props.item.status == 'completed'"
        >
          Completed
        </v-chip>
        <v-chip
          color="primary"
          text-color="white"
          v-else-if="props.item.status == 'reported'"
        >
          Reported
        </v-chip>
        <v-chip
          color="orange"
          text-color="white"
          v-else-if="props.item.status == 'scheduled'"
        >
          Scheduled
        </v-chip>
        <v-chip
          color="red"
          text-color="white"
          v-else-if="props.item.status == 'cancelled'"
        >
          Cancelled
        </v-chip>
        <template v-slot:input>
          <v-select
              v-model="props.item.status"
              :items="statuses"
              item-text="label"
              item-value="value"
              label="Status"
          ></v-select>
        </template>
      </v-edit-dialog>
    </template>
    <template v-slot:item.assignee="props">
      <v-edit-dialog
        :return-value.sync="props.item.assignee"
        @save="saveField(props.item.id)"
        large
      >
        {{ getUsername(props.item.assignee) }}
        <template v-slot:input>
          <v-select
              v-model="props.item.assignee"
              :items="users"
              item-text="name"
              item-value="id"
              label="Assignee"
          ></v-select>
        </template>
      </v-edit-dialog>
    </template>
    <template v-slot:item.date="props">
      <v-edit-dialog
        :return-value.sync="props.item.date"
        @save="saveField(props.item.id)"
        large
      >
        {{ formatDate(props.item.date) }}
        <template v-slot:input>

          <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
          >
              <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="props.item.date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
              </template>
              <v-date-picker
              v-model="props.item.date"
              @input="menu = false"
              ></v-date-picker>
          </v-menu>
        </template>
      </v-edit-dialog>
    </template>
  </v-data-table>
</template>

<script>
    import axios from 'axios'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import mixin from '../mixin/main.js'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin],
        data: () => ({
            loading: false,
            dialog: false,
            dialogDelete: false,
            headers: [
                {
                  text: 'Property',
                  align: 'start',
                  sortable: false,
                  value: 'property',
                },
                {
                  text: 'Task',
                  align: 'start',
                  sortable: false,
                  value: 'task',
                },
                { text: 'Status', value: 'status', sortable: false },
                { text: 'Date', value: 'date', sortable: false },
                { text: 'Assignee', value: 'assignee', sortable: false },
                { text: 'Description', value: 'description', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false, align: 'right' },
            ],
            tasks: [],
            properties: [],
            contacts: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                property_id: '',
                task: '',
                status: 'reported',
                date: '',
                assignee: '',
                description: '',
                contact: []
            },
            defaultItem: {
                id: '',
                property_id: '',
                task: '',
                status: 'reported',
                date: '',
                assignee: '',
                description: '',
                contact: []
            },
            statuses: [
                { label: 'Reported', value: 'reported' },
                { label: 'Scheduled', value: 'scheduled' },
                { label: 'Completed', value: 'completed' },
            ],
        }),

        components: {
            ValidationProvider,
            ValidationObserver,
        },

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Task' : 'Edit Task'
            },
            computedDateFormatted () {
                return this.formatDate(this.editedItem.date)
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        created () {
            this.getTasks()
        },

        methods: {
            getTasks() {
                this.loading = true
                axios.get('tasks/all')
                    .then(response => {
                        this.loading = false
                        this.tasks = response.data.tasks
                        this.properties = response.data.properties
                        this.$nextTick()
                    })
            },

            getContacts() {
                this.loading = true
                axios.get('tasks/contacts?property_id=' + this.editedItem.property_id)
                    .then(response => {
                        this.loading = false
                        this.contacts = response.data
                        this.$nextTick()
                    })
            },

            editItem (item) {
                this.editedIndex = this.tasks.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.getContacts()
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.tasks.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.loading = true
                axios.delete('tasks/delete?id=' + this.editedIndex)
                    .then(() => {
                      this.closeDelete()
                      this.getTasks()
                      this.$nextTick()
                    })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            async save () {
                if (this.editedIndex > -1) {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('tasks/update', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getTasks()
                          this.close()
                      }).catch(error => {
                          console.log(error)
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                } else {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('tasks/add', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getTasks()
                          this.close()
                      }).catch(error => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                }
            },

            saveField(id) {
              let item = this.tasks.filter(task => {
                return task.id == id
              })

              if(item.length) {
                axios.post('tasks/update', item[0]).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.getTasks()
                }).catch(error => {
                    console.log(error)
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    if(error.response.data.error) {
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })     
              } 
            },
        },
    }
</script>